export class Provider {
    id: number;
    name: string;
    identNum: string;
    ipRange: string;
    netOwner: string;
    active: boolean;

    constructor() {}
}